// src/services/userServices.js


import {
  AUTH_KEYS,
  atualizarDadosAssinatura,
  limparSessaoPsyAssist,
} from "./authStorage";

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://api.psyassist.com.br"
).replace(/\/$/, "");

function safeGetItem(storage, key) {
  try {
    return storage?.getItem(key) || "";
  } catch (error) {
    console.error(
      `Erro ao ler ${key} do storage:`,
      error
    );
    return "";
  }
}

function getStorageWithToken() {
  const sessionToken =
    safeGetItem(sessionStorage, AUTH_KEYS.TOKEN) ||
    safeGetItem(sessionStorage, "token");

  if (sessionToken) {
    return {
      storage: sessionStorage,
      otherStorage: localStorage,
      token: sessionToken,
    };
  }

  const localToken =
    safeGetItem(localStorage, AUTH_KEYS.TOKEN) ||
    safeGetItem(localStorage, "token");

  if (localToken) {
    return {
      storage: localStorage,
      otherStorage: sessionStorage,
      token: localToken,
    };
  }

  return {
    storage: null,
    otherStorage: null,
    token: "",
  };
}

function removerChavesAuth(storage) {
  if (!storage) {
    return;
  }

  const keys = Array.from(
    new Set([
      ...Object.values(AUTH_KEYS),
      "token",
    ])
  );

  keys.forEach((key) => {
    try {
      storage.removeItem(key);
    } catch {
      // O fluxo não deve falhar por indisponibilidade do storage.
    }
  });
}

function atualizarTokenRetornado(response, storage) {
  const newToken = response.headers.get("x-new-token");

  if (!newToken || !storage) {
    return null;
  }

  try {
    storage.setItem(AUTH_KEYS.TOKEN, newToken);
  } catch {
    // Mantém o token anterior caso o storage esteja indisponível.
  }

  return newToken;
}

export function obterTokenAutenticacao() {
  return getStorageWithToken().token;
}

export function limparSessaoAutenticacao() {
  limparSessaoPsyAssist();

  try {
    sessionStorage.removeItem("token");
    localStorage.removeItem("token");
  } catch {
    // Ignora falha de limpeza do storage.
  }
}

export async function buscarUsuarioAtual() {
  const {
    storage,
    token,
  } = getStorageWithToken();

  if (!token) {
    const error = new Error(
      "Token de autenticação não encontrado."
    );

    error.status = 401;
    throw error;
  }

  const response = await fetch(
    `${API_BASE}/psy/user/me`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await response
    .json()
    .catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data?.message ||
      `Erro ao consultar usuário atual (HTTP ${response.status}).`
    );

    error.status = response.status;
    error.data = data;

    throw error;
  }

  const refreshedToken =
    atualizarTokenRetornado(
      response,
      storage
    );

  return {
    ...data,
    accessToken:
      refreshedToken ||
      token,
  };
}

export async function sincronizarUsuarioAtual() {
  const {
    storage,
    otherStorage,
  } = getStorageWithToken();

  const user = await buscarUsuarioAtual();

  /*
   * Atualiza plano, assinatura, recursos e dados básicos usando o serviço
   * central de autenticação.
   */
  atualizarDadosAssinatura(user);

  /*
   * authStorage mantém compatibilidade gravando nos dois storages.
   * Aqui restauramos a escolha original do login:
   * - token na sessão => mantém somente sessionStorage;
   * - token local => mantém somente localStorage.
   */
  removerChavesAuth(otherStorage);

  if (storage) {
    try {
      storage.setItem(
        AUTH_KEYS.TOKEN,
        user.accessToken
      );
    } catch {
      // O usuário continuará com o token anterior.
    }
  }

  return user;
}
